<template>
  <div class="bottom-dots">
    <span class="dot " v-bind:class="{ 'active-dot': step === 'step1' }"></span>
    <span class="dot " v-bind:class="{ 'active-dot': step === 'step2' }"></span>
    <!-- <span class="dot"></span> -->
    <span class="dot" v-bind:class="{ 'active-dot': step === 'step3' }"></span>
  </div>
</template>

<script>
export default {
  name: "bottomDots",
  props: ["step"],
};
</script>

<style scoped>
.bottom-dots {
  position: absolute;
  bottom: 10px;
}
.dot {
  height: 10px;
  width: 10px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 50%;
  display: inline-block;
  margin: 10px;
}
.active-dot {
  background: #4192d9 0% 0% no-repeat padding-box;
}
</style>
